import React from 'react';

export const FormInput = ({ label, name, type = 'text', value, onChange, required, placeholder, rows }) => (
  <div style={{ marginBottom: '1rem' }}>
    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500 }}>{label} {required && '*'}</label>
    {type === 'textarea' ? (
      <textarea name={name} value={value || ''} onChange={onChange} rows={rows || 3} placeholder={placeholder} required={required} style={{ width: '100%', padding: '0.75rem', border: '1px solid #E2E8F0', borderRadius: '8px' }} />
    ) : type === 'select' ? (
      <select name={name} value={value || ''} onChange={onChange} required={required} style={{ width: '100%', padding: '0.75rem', border: '1px solid #E2E8F0', borderRadius: '8px' }}>
        {placeholder && <option value="">{placeholder}</option>}
        {onChange.options?.map(opt => <option key={opt.value} value={opt.value}>{opt.label}</option>)}
      </select>
    ) : type === 'checkbox' ? (
      <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <input type="checkbox" name={name} checked={value || false} onChange={onChange} style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
        <span>{label}</span>
      </label>
    ) : (
      <input type={type} name={name} value={value || ''} onChange={onChange} placeholder={placeholder} required={required} style={{ width: '100%', padding: '0.75rem', border: '1px solid #E2E8F0', borderRadius: '8px' }} />
    )}
  </div>
);